import measure from "./measure"

export default function slantDistance(remote, local) {
	const lat1 = remote.position.latitude
	const lon1 = remote.position.longitude
	const lat2 = local.position.latitude
	const lon2 = local.position.longitude
	const alt1 = remote.position.gnssAltitude
	const alt2 = local.position.gnssAltitude
  
	const dist = measure(lat1, lon1, lat2, lon2)

	const hypotenuse = Math.sqrt(Math.pow(dist, 2) + Math.pow(alt2 - alt1, 2))

	return Math.round(hypotenuse)
}